import * as _ from 'lodash-es';

import {
  GenericObject as GO,
  SPECIAL_JOB_ITEM as ITM,
  isRectShape,
  isRoundShape,
  isRealPipe,
  isFlexSymbol,
} from '../types';

/**
 * Basic function to Compose label with different category
 * for PIPE fitting/length, only have two values
 
 * @param detail
 * @param sparse
 * @param category possible useful?
 * @returns
 */
const composeLabel = (detail: GO, sparse?: boolean) => {
  const space = sparse ? ' ' : '';
  const diameter = detail['diameter_1'] || 'None';
  const width = detail['width'] || detail['width_1'] || 'None';
  const height =
    detail['height'] ||
    detail['height_1'] ||
    detail['height_2'] ||
    detail['width_2'] ||
    'None';
  const system = detail['system'] || 'None'; // system not a must to show
  // const hasDiameter = !_.isUndefined(detail['diameter_1']);

  // ! add length_unit_str for pipe & duct length
  // @2026/01/20
  const lengthStr = detail['length_unit_str'] || 'None';

  const diffuserCode = detail['diffuser_code'] || 'None';
  const hasDiffuserCode = !_.isUndefined(detail['diffuser_code']);
  // for custom symbol
  const name = detail['name'] || '';
  const hasNameField = !_.isUndefined(detail['name']);

  // size with space
  const systemText = [space, system];
  const widthText = [width, space, '/'];
  const heighText = [space, height, space, '/'];
  const diameterText = [diameter, space, '/'];
  const diffuserCodeText = [diffuserCode, space, '/'];
  // custom fitting property:
  const nameText = [name, space, '/'];
  // lengthText fot debug - @2026/01/20
  // const lengthStrText = [lengthStr, space, '/'];

  // FIXME: check shape to decide the label - @2023/08/23
  // ! use upper case to decide if it's shape matched in order to keep back-compatible
  // @2025/09/04
  const shape: string | undefined = detail['shape'];
  // ! FIXME: PIPE_LENGTH is `round` although it does not have shape definition
  // @2025/09/10
  const isPipe = isRealPipe(detail['category']);
  if (isRoundShape(shape) || isPipe) {
    return [...diameterText, ...systemText].join('');
  }
  // for rect symbol - @2025/08/27
  if (isRectShape(shape)) {
    return [...widthText, ...heighText, ...systemText].join('');
  }

  // FIXME: CUSTOM_DUCT_FITTING or CUSTEOM_PIPE_FITTING
  // @2024/04/26
  if (hasNameField) {
    return [...nameText, ...systemText].join('');
  }

  // for diffusers
  if (hasDiffuserCode) {
    const diffuserLabel = diffuserCodeText.concat(systemText);
    return diffuserLabel.join('');
  }

  // default size label for rectangular fittings
  const groups = widthText.concat(heighText).concat(systemText);
  return groups.join('');
};

/**
 * Use `name`/`subtype`/`identifier`/`s_number` to compose equipment text
 *
 * @param detail
 * @returns
 */
export const composeEquipmentText = (detail: GO) => {
  const name = detail['name'] ? `${detail['name']}` : '';
  const subtype = detail['subtype'] ? `/${detail['subtype']}` : '';
  // FIXME: use `identifier` first then fallback to `s_number`
  // @2024/12/03
  const identifier = detail['identifier'] ? `/${detail['identifier']}` : '';
  // const system = detail['system'] || '';
  // FIXME: use serial number as the 3rd segment instead of system
  // @2023/08/04
  const sNumber = detail['s_number'] ? `/${detail['s_number']}` : '';
  const pairs = `${name}${subtype}${identifier}${sNumber}`;
  return pairs;
};

/**
 * Safe method to compose a label for symbol
 *
 * @log get label for note symbol from `content` - 2025/10/08
 * @log add FLEX label - 2025/12/04
 *
 * @param detail
 * @returns
 */
export const composeLabelBySymbol = (detail: GO) => {
  const { entityType, diameter_1, system, zone } = detail;

  // == special cases checking! ==
  if (entityType === ITM.TBX) return detail['content'];
  if (entityType === ITM.EQMT) return composeEquipmentText(detail);
  // ! for flex symbol - @2025/12/04
  if (entityType === ITM.FLEX) {
    return `${diameter_1 || 'None'} / ${system || 'None'} / ${zone || 'None'}`;
  }

  return composeLabel(detail, true);
};
